const calculateUserResultPercentage = userResults => {
    let trueArrays = []

    userResults.forEach(el => el ? trueArrays.push(el) : trueArrays)

    return trueArrays.length * 10
}

export default calculateUserResultPercentage